"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/TCFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_221)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_221`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-8.04004 0H27.96V24.0003H-8.04004V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.3079 7.49976V12.9997C15.3079 15.6788 18.96 16.4998 18.96 16.4998C18.96 16.4998 22.6122 15.6789 22.6122 12.9997V7.49976H15.3079Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.4382 9.49974C18.4382 10.052 17.971 11.4998 17.3948 11.4998C16.8185 11.4998 16.3513 10.0521 16.3513 9.49974C16.3513 8.94737 17.3948 8.49976 17.3948 8.49976C17.3948 8.49976 18.4382 8.94744 18.4382 9.49974Z",
					fill: "#FF9811"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.2073 10.5889C21.3757 10.1951 21.5067 9.61962 21.5067 9.3331C21.5067 8.87283 20.8806 8.49976 20.8806 8.49976C20.8806 8.49976 20.2545 8.87283 20.2545 9.3331C20.2545 9.61962 20.3855 10.1951 20.5539 10.5889L20.1924 11.371C20.4118 11.4563 20.6452 11.5 20.8806 11.4997C21.1241 11.4997 21.3563 11.4537 21.5688 11.371L21.2073 10.5889Z",
					fill: "#A2001D"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.1773 12.9997C18.1773 12.9997 17.6555 13.9997 17.6555 14.9997H20.2642C20.2642 13.9997 19.7424 12.9997 19.7424 12.9997L18.9598 12.4997L18.1773 12.9997Z",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.7426 12.9997V12.7497C19.7426 12.3355 19.3923 11.9998 18.9601 11.9998C18.5279 11.9998 18.1775 12.3356 18.1775 12.7497V12.9997H19.7426Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.95998 0V2.14826L6.78417 3.91304H9.95998V8.08672H5.80429L9.95998 10.3954V11.9998H8.08404L2.91649 9.12917V11.9998H-0.996548V8.58446L-7.14398 11.9998H-8.04004V9.85143L-4.86423 8.08672H-8.04004V3.91304H-3.88436L-8.04004 1.60355V0H-6.1641L-0.996548 2.87051V0H2.91649V3.41522L9.06392 0H9.95998Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.08497 -0.000183105H-0.165031V4.87473H-8.04004V7.12473H-0.165031V11.9998H2.08497V7.12473H9.95998V4.87473H2.08497V-0.000183105Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.9165 8.08673L9.95999 11.9998V10.8933L4.90825 8.08673H2.9165Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.9165 8.08673L9.95999 11.9998V10.8933L4.90825 8.08673H2.9165Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M2.91649 8.08673L9.95998 11.9998V10.8933L4.90823 8.08673H2.91649ZM-2.98836 8.08673L-8.04004 10.8933V11.9998L-0.996548 8.08673H-2.98836Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-0.996548 3.91285L-8.04004 -0.000183105V1.10633L-2.98829 3.91285H-0.996548ZM4.9083 3.91285L9.95998 1.10633V-0.000183105L2.91649 3.91285H4.9083Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_221`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as TCFlag };
